// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2BY52","bigColWidth":"Table_bigColWidth__2NF0q","biggerColWidth":"Table_biggerColWidth__3Qhzo","row":"Table_row__3Bdzh","col":"Table_col__2j9c4"};